import React from 'react';

function SideMenuTitle({ title, icon, menuExpanded }) {
	return (
		<div style={{
			display: 'flex',
			alignItems: 'center',
			justifyContent: menuExpanded ? 'flex-start' : 'center', // Centrar cuando está colapsado
			padding: menuExpanded ? '10px 15px' : '15px 0', // Ajustar padding cuando está colapsado
			backgroundColor: 'var(--bs-primary-disabled)',
			borderBottom: '1px solid #ddd',
			color: '#666',
			fontWeight: 'bold',
			fontSize: menuExpanded ? '0.9em' : '1.2em', // Tamaño de fuente más grande cuando está colapsado
			textTransform: 'uppercase',
			whiteSpace: 'nowrap',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			marginTop: '-0.8rem'
		}}>
			{icon && (
				<i
					className={`fa ${icon}`}
					style={{
						marginRight: menuExpanded ? '10px' : '0', // Eliminar margen cuando está colapsado
						fontSize: menuExpanded ? '1.2em' : '1.5em', // Ícono más grande cuando está colapsado
					}}
				/>
			)}
			{menuExpanded && title}
		</div>
	);
}

export default SideMenuTitle;